import { message } from 'antd';
import {
  agentSetup,
  agentSetupLine,
  agentSetupPath,
  dashboardUrls,
} from '@todesktop/v2-recipes/agent-setup';
import { stage } from '../../~reusables/firebase/config';

/*
  The "Set up with your coding agent" prompt: one line with the app's ID that
  points an agent at this stage's /agent-setup.md (written at build by
  vite.config.mjs from the same agentSetup()). The Overview and ⌘K copy it.
*/

export const agentSetupUrl = `${dashboardUrls[stage]}${agentSetupPath}`;

export const agentPromptFor = (appId: string) =>
  agentSetupLine({ appId, stage });

/** What the agent fetches, shown under "See the prompt". */
export const agentInstructions = () => agentSetup({ stage });

/** Copies the prompt; false when the browser refused. */
export const copyAgentPrompt = (appId: string) =>
  navigator.clipboard.writeText(agentPromptFor(appId)).then(
    () => true,
    () => {
      void message.error('Couldn’t copy the setup prompt');
      return false;
    },
  );

const hiddenKey = 'v2.overview.agentSetupHidden';

/** Whether this person chose "Don't show this again" (in this browser). */
export const readAgentCardHidden = () => {
  try {
    return window.localStorage.getItem(hiddenKey) === '1';
  } catch {
    return false;
  }
};

export const writeAgentCardHidden = (hidden: boolean) => {
  try {
    if (hidden) window.localStorage.setItem(hiddenKey, '1');
    else window.localStorage.removeItem(hiddenKey);
  } catch {
    // Private windows can refuse storage; the card then hides until reload.
  }
};
